import { render, staticRenderFns } from "./ImportDownDialog.vue?vue&type=template&id=5522f40a&scoped=true&"
import script from "./ImportDownDialog.vue?vue&type=script&lang=js&"
export * from "./ImportDownDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImportDownDialog.vue?vue&type=style&index=0&id=5522f40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5522f40a",
  null
  
)

export default component.exports